// extracted by mini-css-extract-plugin
export default {"main":"BreadCrumb_main__GCygZ","breadCrumb":"BreadCrumb_breadCrumb__L2cpn","crumb":"BreadCrumb_crumb__AIeP0","separator":"BreadCrumb_separator__tlgQT"};